import { Pais } from '@rpe/registro-personas-empresas-lib';
import { Telefono } from './telefonos.model';

export function telefonosToString(tels: Telefono[], paises: Pais[]): string {
  let retTels = '';
  if (tels) {
    tels.forEach((t) => {
      if (t.pais_codigo) {
        const pais = paises.find((p) => p.codigo == t.pais_codigo);
        retTels += '(' + pais.codigo_telefonico + ') ' + t.telefono + ', ';
      } else {
        retTels += t.telefono + ', ';
      }
    });
    retTels = retTels.slice(0, -2);
  } else {
    retTels = 'No tiene teléfonos';
  }
  return retTels;
}
